import { z } from 'zod';
export const ScanInboxStatusSchema = z.enum([
    'RECEIVED',
    'PROCESSED',
    'QUARANTINED',
    'FAILED',
    'SKIPPED',
]);
const prefixField = z
    .string()
    .min(1)
    .max(128)
    .transform((s) => s.trim().toLowerCase());
export const ScanIntakeRouteCreateSchema = z.object({
    prefix: prefixField,
    companyId: z.uuid(),
    active: z.boolean().default(true),
});
export const ScanIntakeRouteSchema = z.object({
    id: z.uuid(),
    prefix: z.string(),
    companyId: z.uuid(),
    active: z.boolean(),
    createdAt: z.string(),
});
export const ScanInboxFileSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid().nullable(),
    providerFileId: z.string(),
    bucket: z.string(),
    prefix: z.string().nullable(),
    fileName: z.string(),
    mimeType: z.string().nullable(),
    sizeBytes: z.number().int().nonnegative(),
    status: ScanInboxStatusSchema,
    reason: z.string().nullable(),
    archiveKey: z.string().nullable(),
    ingestId: z.uuid().nullable(),
    createdAt: z.string(),
});
export const ScanIntakeStatusSchema = z.object({
    enabled: z.boolean(),
    bucket: z.string().nullable(),
    lastPollAt: z.string().nullable(),
    hasCursor: z.boolean(),
    lastError: z.string().nullable(),
});
//# sourceMappingURL=scan-intake.js.map